export default "__VITE_ASSET__c41edd73__"